import React from 'react';
import Image from 'next/image';

export default function Hero() {

  return (
    <section className='relative flex flex-col items-center justify-center z-20'>
      <Image
        className='object-cover sm:object-fill'
        src='/background/wiki/hero.webp'
        alt='background hero image'
        fill
        priority
      />
      <div className='relative flex flex-col justify-center items-center mt-10 lg:mt-[150px] mb-24 lg:mb-32 lg:max-w-screen-lg px-2'>
        <div className='flex flex-col items-center justify-center text-center w-full'>
          <h1 className='text-[32px] lg:text-[44px] text-white font-georgia font-[700] leading-tight drop-shadow-[0px_2px_0px_black]'>
            Card Encyclopedia: Explore the Vast World of DECISION Network Cards.
          </h1>
          <p className='text-[16px] lg:text-[20px] text-white font-ubuntu font-[400] leading-tight max-w-screen-xl mt-4'>
            On our Cards Wiki page, you`ll find an extensive catalog of all the
            99 cards available in the DECISION Network universe. Whether you`re
            a seasoned player or new to the game, this resource will be your
            gateway to mastering the art of card selection and crafting winning
            strategies. Discover DECISIONS cards across three elemental realms:
            Fire, Water, and Nature, each with its own distinctive powers and
            strategies.
          </p>

        </div>
      </div>
    </section>
  );
}
